/*
* Created by Skeets 2017-12-04
* Recreated by Skeets 2020-01-25, added promptInput() and ShowAlert() to make it modal.js instead of confirm.js
* */

function showAlert(obj, title)
{
  if (typeof obj !== "object") {
    obj = {msg: obj};
  }
  if (typeof title !== "undefined" && title !== null && title.length > 0) {
    obj.title = title;
  }
  obj = modalJs.prepareObj(obj, {title: "Info", msg: "", noCancel: true, yes: "Ok"});
  modalJs.appendDialog(obj);
  modalJs.releaseBindings(obj);
  modalJs.elements.$modal.modal("show");
}

function onConfirm(obj)
{
  obj = modalJs.prepareObj(obj);

  if (typeof obj.skip !== "undefined" && obj.skip === true) {
    obj.yesCallback(obj.yesParams);
    obj.yesHiddenCallback(obj.yesParams);
    return true;
  }

  modalJs.appendDialog(obj);
  modalJs.bindings(obj);
  modalJs.elements.$modal.modal("show");
}

function promptInput(vars, obj)
{
  obj           = modalJs.prepareObj(obj, {msg: "", title: "Set value", yes: "Go"});
  var inputHtml = modalJs.prepareInputHtml(vars);
  obj.msg += inputHtml;
  modalJs.appendDialog(obj);
  modalJs.bindings(obj);
  modalJs.elements.$modal.on('shown.bs.modal', function() {
    var $firstInput = modalJs.elements.$modal.find("input:first");
    if ($firstInput.length) {
      $firstInput.focus();
      $firstInput[0].select();
    }

    modalJs.elements.$modal.off('shown.bs.modal');
  });
  modalJs.elements.$modal.modal("show");
  if (typeof conditionalJsAuto !== "undefined") {
    conditionalJsAuto(modalJs.elements.$body);
  }
  var $bootstrapTooltips = modalJs.elements.$body.find("[data-toggle='tooltip']");
  if ($bootstrapTooltips.length) {
    $bootstrapTooltips.tooltip();
  }

}

var modalJs = {
  dialogAppended  : false,
  cancelBtnClass  : "btn-secondary",
  modalClass      : "",
  class           : "",
  elements        : {
    $modal           : null,
    $dialog          : null,
    $content         : null,
    $header          : null,
    $body            : null,
    $footer          : null,
    $title           : null,
    $cancel          : null,
    $ok              : null,
    $elementPreserver: null
  },
  config          : function(options) {
    for (var option in options) {
      if (options.hasOwnProperty(option)) {
        modalJs[option] = options[option];
      }
    }
  },
  adjustTimer     : function($button) {
    var $timerEle    = $button.find(".modalJs-timer");
    var currentTimer = $button.data("timer") - 1;
    $button.data("timer", currentTimer);
    $timerEle.html("(" + currentTimer + ")");
    if (currentTimer > 0) {

      clearTimeout($button.data("timeout"));
      var thisTimeout = setTimeout(function() {
        modalJs.adjustTimer($button);
      }, 1000);
      $button.data("timeout", thisTimeout);
    }
    else {
      $timerEle.remove();
      $button.removeClass("disabled").prop("disabled", false);
    }
  },
  appendDialog    : function(obj) {
    if (modalJs.dialogAppended) {
      modalJs.elements.$title.html(obj.title);
      modalJs.elements.$body.html(obj.msg);
      modalJs.renderFooter(modalJs.elements.$footer, obj);
      modalJs.startTimer(modalJs.elements.$ok, obj.timer);
      modalJs.elements.$modal.on('hidden.bs.modal', function() {
        modalJs.elements.$body.html("");
      });
      return true;
    }
    var elements      = {};
    elements.$form    = $("<form/>", {id: "modal-js-form"});
    elements.$modal   = $("<div/>", {
      class: "modal fade " + modalJs.class,
      role : "dialog",
      id   : "confirm-js-dialog"
    });
    elements.$dialog  = $("<div/>", {class: "modal-dialog", role: "document"});
    elements.$content = $("<div/>", {class: "modal-content " + modalJs.modalClass});
    elements.$header  = $("<div/>", {class: "modal-header"});
    elements.$body    = $("<div/>", {class: "modal-body"});
    elements.$footer  = $("<div/>", {class: "modal-footer"});
    elements.$title   = $("<h5/>", {class: "modal-title"});


    elements.$title.append([obj.icon, obj.title]);
    elements.$body.append(obj.msg);


    elements.$header.append(elements.$title);
    elements.$content.append([elements.$header, elements.$body, elements.$footer]);
    elements.$dialog.append(elements.$content);
    elements.$modal.append(elements.$dialog);
    elements.$form.append(elements.$modal);


    modalJs.elements = elements;
    modalJs.renderFooter(elements.$footer, obj);

    modalJs.startTimer(elements.$ok, obj.timer);

    $("body").append(elements.$form);
    modalJs.elements.$modal.on('hidden.bs.modal', function() {
      modalJs.elements.$body.html("");
    });
    modalJs.dialogAppended = true;
  },
  renderFooter    : function($footer, obj) {
    $footer.html("");
    var $cancel = $("<button/>", {type: "button", class: "btn " + modalJs.cancelBtnClass, "data-dismiss": "modal"});
    var $ok     = $("<button/>", {type: "submit", class: "btn btn-" + obj.yesType});

    $cancel.html(obj.no);
    $ok.html(obj.yes);
    if (typeof obj.customFooter !== "undefined" && obj.customFooter !== null) {
      $footer.html(obj.customFooter);
      if ($footer.find(".modalJs-cancel").length) {
        modalJs.elements.$cancel = $footer.find(".modalJs-cancel");
      }
      else {
        modalJs.elements.$cancel = $cancel;
      }
      if ($footer.find(".modalJs-submit").length) {
        modalJs.elements.$ok = $footer.find(".modalJs-submit");
      }
      else {
        modalJs.elements.$ok = $ok;
      }
    }
    else {
      $footer.append([$cancel, $ok]);
      modalJs.elements.$cancel = $cancel;
      modalJs.elements.$ok     = $ok;
      modalJs.elements.$ok.attr("class", "btn btn-" + obj.yesType);
    }

    if (obj.noCancel) {
      modalJs.elements.$cancel.hide();
    }
    else {
      modalJs.elements.$cancel.show();
    }
  },
  setDefaults     : function(obj, overrideDefaults) {
    var defaults = {
      title            : "Are you sure?",
      icon             : "",
      msg              : "Are you sure?",
      yes              : "Yes",
      no               : "Cancel",
      hideOnSubmit     : true,
      beforeInput      : "",
      afterInput       : "",
      customFooter     : null,
      onHidden         : false,
      yesCallback      : function() {
      },
      yesHiddenCallback: function() {
      },
      yesParams        : [],
      yesType          : "success",
      noCallback       : function() {
      },
      noHiddenCallback : function() {
      },
      noParams         : [],
      noCancel         : false,
      timer            : 0

    };

    for (var overrideProperty in overrideDefaults) {
      if (overrideDefaults.hasOwnProperty(overrideProperty)) {
        if (!obj.hasOwnProperty(overrideProperty)) {
          obj[overrideProperty] = overrideDefaults[overrideProperty];
        }
      }
    }
    for (var property in defaults) {
      if (defaults.hasOwnProperty(property)) {
        if (!obj.hasOwnProperty(property)) {
          obj[property] = defaults[property];
        }
      }
    }

    return obj;
  },
  setAliases      : function(obj) {
    var aliases = {msg: ["body"], yesCallback: ["callback"], yes: ["go"], no: ["cancel"]};

    for (var aliasedField in aliases) {
      if (aliases.hasOwnProperty(aliasedField)) {
        aliases[aliasedField].forEach(function(alias) {
          if (obj.hasOwnProperty(alias)) {
            obj[aliasedField] = obj[alias];
          }
        });
      }
    }
    return obj;
  },
  releaseBindings : function() {
    modalJs.elements.$form.off().on("submit", function(e) {
      e.preventDefault();
      modalJs.elements.$modal.modal("hide");
    });
    modalJs.elements.$cancel.off();
    modalJs.elements.$modal.off();
  },
  bindings        : function(obj) {
    var $modal = modalJs.elements.$modal;

    modalJs.elements.$form.off().on("submit", function(e) {
      e.preventDefault();
      var data     = {};
      var formData = new FormData(this);

      formData.forEach(function(value, property) {
        data[property] = value;
      });


      for (var attrName in obj.yesParams) {
        if (obj.yesParams.hasOwnProperty(attrName)) {
          data[attrName] = obj.yesParams[attrName];
        }
      }

      if (obj.onHidden) {
        $modal.on('hidden.bs.modal', function() {
          obj.yesCallback(data);
          $modal.off('hidden.bs.modal');
        });
      }
      else {
        obj.yesCallback(data);
      }
      $modal.on('hidden.bs.modal', function() {
        obj.yesHiddenCallback(window, data);
        $modal.off('hidden.bs.modal');
      });
      if (obj.hideOnSubmit) {
        $modal.modal("hide");
      }
    });

    modalJs.elements.$cancel.off().on("click", function() {
      if (obj.onHidden) {
        $modal.on('hidden.bs.modal', function(e) {
          obj.noCallback(obj.noParams);
          $modal.off('hidden.bs.modal');
        });
      }
      else {
        obj.noCallback(obj.noParams);
      }
      $modal.on('hidden.bs.modal', function(e) {
        obj.noHiddenCallback(window, obj.noParams);
        $modal.off('hidden.bs.modal');
      });
      $modal.modal("hide");
    });
  },
  inputBuilders   : {
    text     : function(options, name, id) {
      var labelDivAttr;
      if (typeof options.labelWidth !== "undefined" && options.labelWidth !== null) {
        labelDivAttr = " style='width: " + options.labelWidth + "px;' ";
      }
      var output = "";
      output += "<div class='row mb-3'>";
      if (typeof options.hideLabel === "undefined" || options.hideLabel !== true) {
        output += "<div class='col-auto d-flex align-items-center'" + labelDivAttr + ">";
        output += "<label class='mb-0' for='" + id + "'>" + options.label + "</label>";
        output += "</div>";
      }
      output += "<div class='col'>";
      output +=
        "<input " +
        options.attr +
        " value='" +
        modalJs.escapeHtml(options.default) +
        "'" +
        " type='" +
        options.inputType +
        "' id='" +
        id +
        "' class='form-control " +
        options.class +
        "' name='" +
        name +
        "'";
      if (typeof options.placeholder !== "undefined" && options.placeholder !== null && options.placeholder.length > 0) {
        output += " placeholder='" + options.placeholder + "'";
      }
      output += ">";
      output += "</div>";
      output += "</div>";
      return output;
    }, hidden: function(options, name, id) {
      var output = "";
      output +=
        "<input " +
        options.attr +
        " value='" +
        modalJs.escapeHtml(options.default) +
        "'" +
        " type='hidden' id='" +
        id +
        "' class='form-control " +
        options.class +
        "' name='" +
        name +
        "'";
      output += ">";
      return output;
    },
    textarea : function(options, name, id) {
      var output = "";
      output += "<div class='row'>";
      if (typeof options.hideLabel === "undefined" || options.hideLabel !== true) {
        output += "<div class='col' >";
        output += "<label for='" + id + "'>" + options.label + "</label>";
        output += "</div>";
      }
      output += "</div>";
      output += "<div class='row mb-3'>";
      output += "<div class='col'>";
      output += "<textarea " + options.attr + " id='" + id + "' class='form-control " + options.class + "' name='" + name + "'";
      if (typeof options.placeholder !== "undefined" && options.placeholder !== null && options.placeholder.length > 0) {
        output += " placeholder='" + options.placeholder + "'";
      }
      output += ">";
      output += modalJs.escapeHtml(options.default)
                + "</textarea>";
      output += "</div>";
      output += "</div>";
      return output;
    },
    select   : function(options, name, id) {
      var labelDivAttr;
      if (typeof options.labelWidth !== "undefined" && options.labelWidth !== null) {
        labelDivAttr = " style='width: " + options.labelWidth + "px;' ";
      }
      if (typeof options.selectOptions === "undefined" || options.selectOptions === null) {
        if (typeof options.radioOptions !== "undefined" && options.radioOptions !== null) {
          options.selectOptions = options.radioOptions;
        }
      }
      var selected = "";
      var output   = "";
      output += "<div class='row mb-3'>";
      if (typeof options.hideLabel === "undefined" || options.hideLabel !== true) {
        output += "<div class='col-auto d-flex align-items-center'" + labelDivAttr + ">";
        output += "<label class='mb-0' for='" + id + "'>" + options.label + "</label>";
        output += "</div>";
      }
      output += "<div class='col'>";
      output +=
        "<select " + options.attr + " id='" + id + "' class='form-control " + options.class + "' name='" + name + "'>";
      for (var value in options.selectOptions) {
        selected = "";
        if (value === options.default) {
          selected = " selected ";
        }
        if (options.selectOptions.hasOwnProperty(value)) {
          output += "<option " + selected + " value='" + value + "'>" + options.selectOptions[value] + "</option>";
        }
      }
      output += "</select>";
      output += "</div>";
      output += "</div>";
      return output;
    },
    radio    : function(options, name, id) {
      if (typeof options.radioOptions === "undefined" || options.radioOptions === null) {
        if (typeof options.selectOptions !== "undefined" && options.selectOptions !== null) {
          options.radioOptions = options.selectOptions;
        }
      }
      var output = "";
      output += "<div class='row mb-3'>";
      output += "<div class='col'>";
      // Took out the card, I don't think it's needed?
      // output += "<div class='card'>";

      if (typeof options.hideLabel === "undefined" || options.hideLabel !== true) {
        // output += "<div class='card-header'>";
        output += "<label class='mb-0' for='" + id + "'>" + options.label + "</label>";
        // output += "</div>";
      }
      // output += "<div class='card-body'>";
      for (var value in options.radioOptions) {
        if (options.radioOptions.hasOwnProperty(value)) {
          var checked = "";
          if (value === options.default) {
            checked = " checked ";
          }
          output += "<label  " + options.attr + "  class='d-block " + options.class + "' >" +
                    "<input" + checked + " type='radio' name='" + name + "' value='" + value + "'>&nbsp;" + options.radioOptions[value] +
                    "</label>";
        }
      }
      output += "</div></div>";
      // output += "</div></div>";
      return output;
    },
    checkbox : function(options, name, id) {
      var output  = "";
      output += "<div class='row mb-3'>";
      output += "<div class='col'>";
      var checked = "";
      if (typeof options.checked !== "undefined" && (options.checked === true || options.checked === "true" || options.checked === "yes")) {
        checked = " checked ";
      }
      var value = "";
      if (typeof options.default !== "undefined" && options.default !== null && options.length > 0) {
        value = " value='" + modalJs.escapeHtml(options.default) + "'";
      }
      if (typeof options.value !== "undefined" && options.value !== null && options.length > 0) {
        value = " value='" + modalJs.escapeHtml(options.value) + "'";
      }
      output += "<label " + options.attr + "  class='" + options.class + "' >" +
                "<input" + checked + " type='checkbox' name='" + name + "'" + value + ">&nbsp;" + options.label +
                "</label>";
      output += "</div>";
      output += "</div>";
      return output;
    },
  },
  prepareInputHtml: function(vars, allowDuplicates) {
    var id;
    if (typeof allowDuplicates === "undefined" || allowDuplicates === null) {
      allowDuplicates = true;
    }
    if (typeof vars !== "object") {
      var tempVar   = vars;
      vars          = {};
      vars[tempVar] = tempVar;
    }

    var inputs  = "";
    var countId = 0;
    for (var prop in vars) {
      if (vars.hasOwnProperty(prop)) {
        id                    = "prompt-js-input-id-" + countId;
        vars[prop].element_id = id;
        countId++;
      }
    }

    countId = 0;

    for (var prop in vars) {
      if (vars.hasOwnProperty(prop)) {
        if (!allowDuplicates && modalJs.dialogAppended && modalJs.elements.$body.find("[name='" + prop + "']").length) {
          continue;
        }
        if (typeof vars[prop] !== "object") {
          vars[prop] = {"label": vars[prop]};
        }
        if (typeof vars[prop].attr === "undefined" || vars[prop].attr === null) {
          vars[prop].attr = "";
        }
        if (typeof vars[prop].class === "undefined" || vars[prop].class === null) {
          vars[prop].class = "";
        }
        id = vars[prop].element_id;
        if (typeof vars[prop].inputType === "undefined") {
          vars[prop].inputType = "text";
        }

        if (typeof vars[prop].showWhenField !== "undefined" && vars[prop].showWhenField !== null
            && typeof vars[prop].showWhenValue !== "undefined" && vars[prop].showWhenValue !== null) {
          var thisId = modalJs.getIdForVar(vars, vars[prop].showWhenField);
          inputs += "<div class='conditional' data-conditional-target='#" + modalJs.escapeHtml(thisId) + "'" +
                    " data-conditional-value='" + modalJs.escapeHtml(vars[prop].showWhenValue) + "'>";
        }
        else {
          inputs += "<div>";
        }


        if (typeof vars[prop].beforeInput !== "undefined" && vars[prop].beforeInput !== null) {
          inputs += vars[prop].beforeInput;
        }
        switch (vars[prop].inputType) {
          case "text":
          default:
            inputs += modalJs.inputBuilders.text(vars[prop], prop, id);
            break;
          case "textarea":
            inputs += modalJs.inputBuilders.textarea(vars[prop], prop, id);
            break;
          case "select":
            inputs += modalJs.inputBuilders.select(vars[prop], prop, id);
            break;
          case "radio":
            inputs += modalJs.inputBuilders.radio(vars[prop], prop, id);
            break;
          case "checkbox":
            inputs += modalJs.inputBuilders.checkbox(vars[prop], prop, id);
            break;
          case "hidden":
            inputs += modalJs.inputBuilders.hidden(vars[prop], prop, id);
            break;
        }
        if (typeof vars[prop].afterInput !== "undefined" && vars[prop].afterInput !== null) {
          inputs += vars[prop].afterInput;
        }
        inputs += "</div>";

        countId++;
      }
    }
    return inputs;
  },
  prepareObj      : function(obj, overrideDefaults) {
    if (typeof obj !== "object") {
      obj = {};
    }

    obj = modalJs.setDefaults(obj, overrideDefaults);
    obj = modalJs.setAliases(obj);
    return obj;
  },
  addInputs       : function(vars, allowDuplicates) {
    if (!modalJs.dialogAppended) {
      throw ("addInputs called before dialog was appended.");
    }
    if (typeof allowDuplicates === "undefined" || allowDuplicates === null) {
      allowDuplicates = false;
    }

    var inputHtml = modalJs.prepareInputHtml(vars, allowDuplicates);
    modalJs.elements.$body.append(inputHtml);


    if (typeof conditionalJsAuto !== "undefined") {
      conditionalJsAuto(modalJs.elements.$body);
    }
    var $bootstrapTooltips = modalJs.elements.$body.find("[data-toggle='tooltip']");
    if ($bootstrapTooltips.length) {
      $bootstrapTooltips.tooltip();
    }

  },


  startTimer: function($button, timer) {
    if (timer > 0) {
      $button.addClass("disabled").prop("disabled", true).append(" <span class='modalJs-timer'>(" + timer + ")</span>").data("timer", timer);
      clearTimeout($button.data("timerTimeout"));
      var thisTimeout = setTimeout(function() {
        modalJs.adjustTimer($button);
      }, 1000);

      $button.data("timeout", thisTimeout);
    }
    else {
      $button.removeClass("disabled").prop("disabled", false);
    }
  },

  escapeHtml : function(text) {
    if (typeof text !== "string") {
      try {
        text = text.toString();
      }
      catch (err) {
        return "";
      }
    }
    return text
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  },
  getIdForVar: function(vars, fieldName) {
    for (var prop in vars) {
      if (vars.hasOwnProperty(prop)) {
        return vars[prop].element_id;
      }
    }
    return "";
  }
};



